export default __webpack_public_path__ + "static/media/hacken-io-logo-vector.42d2b778.svg";